import styled from 'styled-components';


import { MenuItem, token } from '@zillow/constellation';

export const StyledRedMenuItem = styled(MenuItem)`
    color: ${token('colors.red600')};
`;
